export default __webpack_public_path__ + "e1c2c457ae0c9a9c550b64e8f9ae71a2.png";